import { render, staticRenderFns } from "./agenda-schedule-buttons-mobile.vue?vue&type=template&id=47ad12a8&"
import script from "./agenda-schedule-buttons-mobile.vue?vue&type=script&lang=js&"
export * from "./agenda-schedule-buttons-mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports